import {
  Component,
  computed,
  inject,
  InjectionToken,
  OnInit,
  output,
} from '@angular/core';
import { DynamicFormField } from '@kinet-open-network/client/core/forms/ui';
import {
  AutomationActionType,
  IAutomationAction,
  IAutomationActionData,
} from '@kinet-open-network/shared/data-access/model';
import { FormlyModule } from '@ngx-formly/core';

export const ACTION_DATA_TEMPLATE = `
  @if (fields(); as dataFields) {
    <formly-form
      [fields]="dataFields"
      [model]="model"
      (modelChange)="handleModelChange($event)"
    />
  } @else {
    <p class="text-gray-400">Žiadne argumenty</p>
  }
`;

export const ACTION_TOKEN = new InjectionToken<
  IAutomationAction<AutomationActionType>
>('Automation Action');

@Component({
  selector: 'kon-automation-action',
  imports: [FormlyModule],
  template: ACTION_DATA_TEMPLATE,
})
export class ActionComponent<T extends AutomationActionType> implements OnInit {
  readonly action = inject<IAutomationAction<T>>(ACTION_TOKEN);

  actionChange = output<IAutomationAction<T>>();

  defaultModel: Record<string, unknown> = {};

  model: Record<string, unknown> = {};

  fields = computed<DynamicFormField[] | null>(() => null);

  handleModelChange(data: Record<string, unknown>): void {
    this.actionChange.emit({ ...this.action, data: this.modelToData(data) });
  }

  ngOnInit(): void {
    this.model = {
      ...Object.entries(this.dataToModel(this.action.data)).reduce(
        (acc, [key, value]) => {
          if (value !== undefined) {
            acc[key] = value;
          }
          return acc;
        },
        this.defaultModel,
      ),
    };
  }

  protected dataToModel(
    data: Partial<IAutomationActionData<T>>,
  ): Record<string, unknown> {
    return data as Record<string, unknown>;
  }

  protected modelToData(
    model: Record<string, unknown>,
  ): Partial<IAutomationActionData<T>> {
    return model as unknown as IAutomationActionData<T>;
  }
}
